import { PayloadAction } from '@reduxjs/toolkit';
import { resetPasswordRequest, updateUserPassword } from './resetPassword.thunks';
import { createUserFromProspect } from './createUserFromProspect.thunk';
import { AuthState } from './authState';

export const reducers = {
  [resetPasswordRequest?.pending.type]: (state: AuthState): void => {
    state.loading = true;
    state.error = null;
  },
  [resetPasswordRequest?.fulfilled.type]: (state: AuthState): void => {
    state.loading = false;
  },
  [resetPasswordRequest?.rejected.type]: (state: AuthState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [updateUserPassword?.pending.type]: (state: AuthState): void => {
    state.loading = true;
    state.error = null;
  },
  [updateUserPassword?.fulfilled.type]: (state: AuthState): void => {
    state.loading = false;
  },
  [updateUserPassword?.rejected.type]: (state: AuthState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [createUserFromProspect?.pending.type]: (state: AuthState): void => {
    state.loading = true;
    state.error = null;
  },
  [createUserFromProspect?.rejected.type]: (state: AuthState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [createUserFromProspect?.fulfilled.type]:  (state: AuthState): void => {
    state.loading = false;
    state.error = null;
  }
};
